export const allowedWirelessTenants = [
  "DE",
  "NO",
  "SE",
  "DK",
  "NL",
  "BE",
  "ES",
  "GB",
  "FR",
  "AT",
  "CH",
];
